import { useSession } from '@/lib/session';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export const ProfilePage = () => {
  const session = useSession((s) => s.session);
  const signOut = useSession((s) => s.signOut);

  if (!session) return null;
  const { user } = session;

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6 lg:p-10">
      <h1 className="text-3xl font-display">Perfil</h1>
      <Card>
        <CardHeader>
          <CardTitle>Sua conta</CardTitle>
          <CardDescription>Informações básicas do login.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <div>
            <p className="text-xs uppercase text-muted-foreground">Email</p>
            <p className="font-medium">{user.email}</p>
          </div>
          <div>
            <p className="text-xs uppercase text-muted-foreground">Conta criada em</p>
            <p className="font-medium">{new Date(user.created_at).toLocaleDateString('pt-BR')}</p>
          </div>
          <div>
            <p className="text-xs uppercase text-muted-foreground">ID do usuário</p>
            <p className="font-mono text-xs">{user.id}</p>
          </div>
        </CardContent>
      </Card>
      <Button variant="destructive" onClick={signOut}>
        Sair
      </Button>
    </div>
  );
};
